import { Pipe, PipeTransform } from '@angular/core';

import { Product } from '../models';

@Pipe({
    name: 'metaColorLabel',
    standalone: false
})
export class ShopifyMetaFieldColorLabelPipe implements PipeTransform {
  transform(value: Product, field: 'kleur_filter' | 'kleur_label' | 'kleurcode'): any {
    const getLabel = value.metafields?.find(m => m?.key === field);
    return getLabel?.value;
  }
}
